import { render, staticRenderFns } from "./DebugMenuPopup.vue?vue&type=template&id=60a0354b&scoped=true&"
import script from "./DebugMenuPopup.vue?vue&type=script&lang=js&"
export * from "./DebugMenuPopup.vue?vue&type=script&lang=js&"
import style0 from "./DebugMenuPopup.vue?vue&type=style&index=0&id=60a0354b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0354b",
  null
  
)

export default component.exports